import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0C1D2E] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Col 1: Brand */}
          <div className="md:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/79b56ce4-7418-4545-880f-043bd4b903d4_Logo-Oficial.png?v=e4ec89a3137073739724e15345a40407"
              alt="IngemetalSur"
              className="h-14 w-auto object-contain brightness-0 invert mb-5"
            />
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Más de 25 años construyendo infraestructura industrial en Chile. Galpones, obras civiles, locales comerciales y proyectos mineros.
            </p>
            <div className="flex items-center gap-2 mb-2">
              <div className="flex gap-0.5">
                {[1,2,3,4].map(i => (
                  <i key={i} className="ri-star-fill text-[#C88A2A] text-sm"></i>
                ))}
                <i className="ri-star-half-fill text-[#C88A2A] text-sm"></i>
              </div>
              <span className="text-white/40 text-xs">4.5 Google Reviews</span>
            </div>
          </div>

          {/* Col 2: Links */}
          <div>
            <h3 className="text-white font-heading text-sm font-bold mb-5 uppercase tracking-widest">Navegación</h3>
            <ul className="space-y-3">
              {[
                { label: 'Inicio', path: '/' },
                { label: 'Nosotros', path: '/nosotros' },
                { label: 'Servicios', path: '/servicios' },
                { label: 'Proyectos', path: '/proyectos' },
                { label: 'Instalaciones', path: '/instalaciones' },
                { label: 'Contacto', path: '/contacto' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/50 hover:text-[#C88A2A] text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Services */}
          <div>
            <h3 className="text-white font-heading text-sm font-bold mb-5 uppercase tracking-widest">Especialidades</h3>
            <ul className="space-y-3">
              {[
                'Galpones Industriales',
                'Estructuras Metálicas',
                'Locales Comerciales',
                'Obras Civiles',
                'Pisciculturas',
                'Proyectos Mineros',
              ].map((s) => (
                <li key={s}>
                  <Link to="/servicios" className="text-white/50 hover:text-[#C88A2A] text-sm transition-colors duration-200">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div>
            <h3 className="text-white font-heading text-sm font-bold mb-5 uppercase tracking-widest">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-[#C88A2A] text-base"></i>
                </div>
                <span className="text-white/50 text-sm leading-relaxed">
                  Parcela 18, Camino Vecinal, Sector El Retiro, Temuco, Araucanía, Chile
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-[#C88A2A] text-base"></i>
                </div>
                <a href="tel:+56992265118" className="text-white/50 hover:text-white text-sm transition-colors">
                  +56 9 9226 5118
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-[#C88A2A] text-base"></i>
                </div>
                <a href="mailto:contacto@ingemetalsur.cl" className="text-white/50 hover:text-white text-sm transition-colors">
                  contacto@ingemetalsur.cl
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-whatsapp-line text-[#C88A2A] text-base"></i>
                </div>
                <a
                  href="https://wa.me/56992265118?text=Hola%2C%20me%20interesa%20solicitar%20una%20cotizaci%C3%B3n"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-white/50 hover:text-white text-sm transition-colors"
                >
                  WhatsApp directo
                </a>
              </li>
            </ul>

            <div className="mt-6 pt-6 border-t border-white/10">
              <p className="text-white/40 text-xs leading-relaxed mb-1">
                <span className="text-white/60 font-semibold">Horario:</span> Lun–Jue 08:00–18:00, Vie 08:00–14:00
              </p>
              <p className="text-white/40 text-xs leading-relaxed">
                <span className="text-white/60 font-semibold">Cobertura:</span> Todo Chile
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            © {currentYear} IngemetalSur. Todos los derechos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Constructora Temuco · Galpones Industriales Chile · Obras Civiles · Estructuras Metálicas
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;